<a tabindex="0" role="button" (keyup.enter)="$event.target.click()" class="edit-link" data-cy="snowman-menu-container-button" (click)="openSnowmanMenu()">
  <img src="../../../../assets/img/snowman.svg" id="edit_{{ menu.i + 1 }}" class="snowman-img" alt="Open Menu" />
</a>
<!-- Without [ngClass] property binding here, snowman will render outside of container -->
@if (isOpen) {
  <div
    class="snowman-menu-container"
    data-cy="snowman-menu-container"
    [ngClass]="{
      'no-container': !positionToContainer,
      'to-container': positionToContainer,
    }"
  >
    <span class="menu-emp-block">
      <span class="circle-dot">
        <img id="snowman_{{ menu.i + 1 }}" src="../../../../assets/img/snowman.svg" class="snowman-menu" (click)="closeMenu()" alt="Close Menu" tabindex="0" role="button" (keyup.enter)="$event.target.click()" />
      </span>
    </span>
    @for (option of menu.options; track option; let j = $index) {
      <div class="menu-item">
        <a data-cy="snowman-menu-option" tabindex="0" role="button" (keyup.enter)="$event.target.click()" id="event_action_{{ menu.i + j }}" (click)="this.onActionSelect(option)">{{ option }}</a>
      </div>
    }
  </div>
}
@if (isOpen) {
  <div class="overlay" (click)="closeMenu()" (keydown.enter)="closeMenu()" tabindex="0" role="button"></div>
}
